export const subjectNameMaxLength = 35;

export const subjectNameErrorMessage = {
	required: 'Field is required',
	duplicate: 'Name must be unique',
	maxLength: `You’ve exceeded the max ${subjectNameMaxLength} symbols allowed.`,
};
